import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';
import { InfoFormBoxComponent } from '@shared/components/info-form-box/info-form-box.component';
import { FailedTranslation, failureOutlivesEdit } from './ai-translation-outcome';

/** Says why one field in one language got no AI suggestion, under that field. */
@Component({
  selector: 'app-failed-translation-note',
  templateUrl: './failed-translation-note.component.html',
  styleUrl: './failed-translation-note.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButton, InfoFormBoxComponent, TranslatePipe],
})
export class FailedTranslationNoteComponent {
  readonly failure = input.required<FailedTranslation>();
  /** What the field holds now. */
  readonly value = input('');
  /** The field and language this note is about, for the button's accessible name. */
  readonly fieldName = input('');
  readonly disabled = input(false);
  /** Id for the note text, so the field can point at it with aria-describedby. */
  readonly textId = input<string | null>(null);
  readonly testId = input('');

  readonly useRejectedText = output<string>();

  /** The rejected suggestion is in the field and still over the limit. */
  protected readonly isShortening = computed(() =>
    failureOutlivesEdit(this.failure(), this.value())
  );

  protected readonly rejectedText = computed(() => {
    const failure = this.failure();
    return failure.reason === 'tooLong' && !this.isShortening()
      ? (failure.rejectedText ?? null)
      : null;
  });
}
